import type { CSSProperties, ReactNode } from 'react'
import { cx } from './utils/cx'

export type PipVariant = 'default' | 'accent' | 'acid' | 'hot' | 'ink'

interface PipProps {
  variant?: PipVariant
  // Arbitrary background color (CSS value). Use `variant` for the 4 canonical
  // presets; fall back to `bg` only when a component needs a one-off fill.
  bg?: string
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export function Pip({ variant, bg, className, style, children }: PipProps) {
  const mergedStyle = bg ? { ...style, background: bg } : style
  return (
    <span className={cx('st-pip', variant && variant !== 'default' && variant, className)} style={mergedStyle}>
      {children}
    </span>
  )
}
